/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonArticleInfo,
    JsonArticleInfoFromJSON,
    JsonArticleInfoFromJSONTyped,
    JsonArticleInfoToJSON,
} from './JsonArticleInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonArticleInfo
 */
export interface ApiResultOfListOfJsonArticleInfo {
    /**
     * 
     * @type {Array<JsonArticleInfo>}
     * @memberof ApiResultOfListOfJsonArticleInfo
     */
    data?: Array<JsonArticleInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonArticleInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonArticleInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonArticleInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonArticleInfo
     */
    result?: ApiResultOfListOfJsonArticleInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonArticleInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonArticleInfoFromJSON(json: any): ApiResultOfListOfJsonArticleInfo {
    return ApiResultOfListOfJsonArticleInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonArticleInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonArticleInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonArticleInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonArticleInfoToJSON(value?: ApiResultOfListOfJsonArticleInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonArticleInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

